export function menuChangeState(open) {
  return {
    type: '@menu/CLICK',
    open: open,
  };
}
